import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/about/:index',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/about.vue')
  },
  {
    path: '/news-list',
    name: 'news-list',
    component: () => import('../views/news-list.vue'),
    children: [{
      path: '/news/:id',
      name: 'news',
      component: () => import('../views/news.vue'),
    },
    ]
  },
  {
    path: '/news-detail/:id',
    name: 'news-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/news-detail.vue')
  },
  {
    path: '/school-list/:index',
    name: 'school-list',
    component: () => import(/* webpackChunkName: "about" */ '../views/xuexiao-list.vue')
  },
  {
    path: '/school-detail/:id',
    name: 'school-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/xuexiao-detail.vue')
  },
  {
    path: '/server-list',
    name: 'server-list',
    component: () => import('../views/server-list.vue'),
    children: [
      {
        path: '/shenqing/:id',
        name: 'shenqing',
        component: () => import(/* webpackChunkName: "about" */ '../views/shenqing.vue')
      },
      {
        path: '/zhusu/:id',
        name: 'zhusu',
        component: () => import(/* webpackChunkName: "about" */ '../views/zhusu.vue')
      },
      {
        path: '/jieji/:id',
        name: 'jieji',
        component: () => import(/* webpackChunkName: "about" */ '../views/jieji.vue')
      },
      {
        path: '/visa/:id',
        name: 'visa',
        component: () => import(/* webpackChunkName: "about" */ '../views/visa.vue')
      },
      {
        path: '/baoxian/:id',
        name: 'baoxian',
        component: () => import(/* webpackChunkName: "about" */ '../views/baoxian.vue')
      },
      {
        path: '/SIM-Card/:id',
        name: 'SIM-Card',
        component: () => import(/* webpackChunkName: "about" */ '../views/SIM-Card.vue')
      },
      {
        path: '/jiaodui/:id',
        name: 'jiaodui',
        component: () => import(/* webpackChunkName: "about" */ '../views/jiaodui.vue')
      },
    ]
  },
  {
    path: '/shenghuo-list',
    name: 'shenghuo-list',
    component: () => import('../views/shenghuo-list.vue'),
    children: [{
      path: '/faq/:id',
      name: 'faq',
      component: () => import(/* webpackChunkName: "about" */ '../views/faq.vue')
    },
    {
      path: '/shenghuo/:id',
      name: 'shenghuo',
      component: () => import(/* webpackChunkName: "about" */ '../views/shenghuo.vue')
    },
    {
      path: '/lvxing/:id',
      name: 'lvxing',
      component: () => import(/* webpackChunkName: "about" */ '../views/lvxing.vue')
    },
    {
      path: '/qiuzhi/:id',
      name: 'qiuzhi',
      component: () => import(/* webpackChunkName: "about" */ '../views/qiuzhi.vue')
    },
    {
      path: '/fankui/:id',
      name: 'fankui',
      component: () => import(/* webpackChunkName: "about" */ '../views/fankui.vue')
    },
    ]
  },
  {
    path: '/jiaoyu-list',
    name: 'jiaoyu-list',
    component: () => import('../views/jiaoyu-list.vue'),
    children: [{
      path: '/jiaocai/:id',
      name: 'jiaocai',
      component: () => import(/* webpackChunkName: "about" */ '../views/jiaocai.vue')
    },
    {
      path: '/yuyan/:id',
      name: 'yuyan',
      component: () => import(/* webpackChunkName: "about" */ '../views/yuyan.vue')
    },
    {
      path: '/kaoshi/:id',
      name: 'kaoshi',
      component: () => import(/* webpackChunkName: "about" */ '../views/kaoshi.vue')
    },
    ]
  },
  {
    path: '/HSK',
    name: 'HSK',
    component: () => import(/* webpackChunkName: "about" */ '../views/HSK.vue')
  },
  {
    path: '/BCT',
    name: 'BCT',
    component: () => import(/* webpackChunkName: "about" */ '../views/BCT.vue')
  },
  {
    path: '/MCT',
    name: 'MCT',
    component: () => import(/* webpackChunkName: "about" */ '../views/MCT.vue')
  },
  {
    path: '/fuwuNav',
    name: 'fuwuNav',
    component: () => import(/* webpackChunkName: "about" */ '../views/fuwuNav.vue')
  },
  {
    path: '/jiangxuejin-list',
    name: 'jiangxuejin-list',
    component: () => import('../views/jiangxuejin-list.vue'),
    children: [{
      path: '/jiangxuejin/:id',
      name: 'jiangxuejin',
      component: () => import('../views/jiangxuejin.vue'),
    },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
